module.exports = __webpack_public_path__ + "media/components/homepage-hero/static/hero-bg-f8fd9da7b0bb2a468e3d53883ecdc054.jpg";